export const getDeceasedDetailsEnabled = (state) => state.deceasedDetailsEnabled;